import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { TopHeaderService } from 'src/app/core/services/top-header/top-header.service';

@Component({
  templateUrl: './point-balance.page.html',
})

/**
 * Points balance page
 */
export class PointBalancePage implements OnInit, OnDestroy {
  private subsink = new Subscription();
  isMobile = true;

  /**
   * pointSummary
   */
  get business() {
    return this.topHeaderService.business;
  }

  /**
   * @constructor
   */
  constructor(
    private breakpointObserver: BreakpointObserver,
    private topHeaderService: TopHeaderService
  ) {}

  /**
   * ngOnInit()
   */
  ngOnInit(): void {
    this.subsink.add(
      this.breakpointObserver
        .observe(['(min-width: 1181px)'])
        .subscribe((state: BreakpointState) => {
          this.isMobile = !state.matches;
        })
    );
  }

  /**
   * clean up subscriptions
   */
  ngOnDestroy() {
    this.subsink.unsubscribe();
  }
}
